import {PermissionType} from '@hconnect/apiclient'
import React from 'react'
import {Navigate, useParams} from 'react-router'

import {useHasAnyOfPermissions} from '../../shared/hooks/usePermission'

type PathParameter = {
  plantId?: string
}

type Props = {
  children: React.ReactNode
  permissions: PermissionType[]
  plantSelectPath: string
}

export const PlantPermissionsGuardedRoute = ({children, permissions, plantSelectPath}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const hasPlantPermissions = useHasAnyOfPermissions(plantId)

  if (!hasPlantPermissions(permissions)) {
    return <Navigate to={plantSelectPath} />
  }

  return <>{children}</>
}
